<template>
  <div class="container-xxl flex-grow-1 container-p-y">
    <div class="row mt-4">
      <div class="col-md-8 col-12">
        <button class="btn btn-primary waves-effect waves-light mb-5" tabindex="0" aria-controls="DataTables_Table_0"
          type="button" data-bs-toggle="modal" data-bs-target="#add-ticket">
          <span>
            <i class="ti ti-plus ti-xs me-2"></i>
            <span class=" ">Add Ticket</span>
          </span>
        </button>
        <div class="accordion accordion-header-primary" id="accordionStyle1">

          <div class="accordion-item card p-5 pt-0 pb-4">
            <h2 class="accordion-header">
              <div type="button" class="d-flex justify-content-between align-items-center" data-bs-toggle="collapse"
                data-bs-target="#accordionStyle1-1" aria-expanded="true">
                <div>
                  <small class="text-muted">30 Haziran 2023 / #109</small><br>
                  <div class="d-flex justify-content-start mt-n2">
                    <h3 class="mb-0 text-primary">speed problem</h3>
                  </div>
                </div>
                <div class="text-end">
                  <span class="alert alert-warning text-xs"> New </span><br>
                  <i class="ti ti-chevron-right text-muted"></i>
                </div>
              </div>
            </h2>

            <div id="accordionStyle1-1" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
              <hr class="mb-8 mt-2">
              <div class="accordion-body">
                <div class="row g-3">

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-hash"></i>
                      </span>
                      Ticket ID:
                      <strong class="ms-2">109</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-phone"></i>
                      </span>
                      Phone:
                      <strong class="ms-2">09000000000</strong>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-alert-circle"></i>
                      </span>
                      Status:
                      <strong class="ms-2 text-warning">New</strong>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-calendar"></i>
                      </span>
                      Created At:
                      <strong class="ms-2">2023-06-30 02:22</strong>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-message-dots"></i>
                      </span>
                      Issue:
                      <strong class="ms-2">مافي مراجعة شي لو ضايفين صور لفرجيك كيف قاعد بتتقلي ضل خلص تكرم 🤣🤣</strong>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-map-pin"></i>
                      </span>
                      Address:
                      <strong class="ms-2">شام للاتصالات</strong>
                    </div>
                  </div>



                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-notes"></i>
                      </span>
                      Notes:
                      <strong class="ms-2">خلصنا</strong>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-quote"></i>
                      </span>
                      SSR Comment:
                      <strong class="ms-2">لا تزعج الادارة يا مواطن الدنيا عيد</strong>
                    </div>
                  </div>



                </div>
              </div>

              <hr class="mb-2">
              <div class="row mb-4">
                <div class="col-12">
                  <div class="d-grid w-100 mt-4">
                    <button type="button" class="btn btn-primary">
                      <i class="ti ti-edit me-2"></i>
                      <span>Edit</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion-item card p-5 pt-0 pb-4">
            <h2 class="accordion-header">
              <div type="button" class="d-flex justify-content-between align-items-center" data-bs-toggle="collapse"
                data-bs-target="#accordionStyle1-2" aria-expanded="true">
                <div>
                  <small class="text-muted">30 Haziran 2023 / #109</small><br>
                  <div class="d-flex justify-content-start mt-n2">
                    <h3 class="mb-0 text-primary">speed problem</h3>
                  </div>
                </div>
                <div class="text-end">
                  <span class="alert alert-warning text-xs"> New </span><br>
                  <i class="ti ti-chevron-right text-muted"></i>
                </div>
              </div>
            </h2>

            <div id="accordionStyle1-2" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
              <hr class="mb-8 mt-2">
              <div class="accordion-body">
                <div class="row g-3">

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-hash"></i>
                      </span>
                      Ticket ID:
                      <strong class="ms-2">109</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-phone"></i>
                      </span>
                      Phone:
                      <strong class="ms-2">09000000000</strong>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-alert-circle"></i>
                      </span>
                      Status:
                      <strong class="ms-2 text-warning">New</strong>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-calendar"></i>
                      </span>
                      Created At:
                      <strong class="ms-2">2023-06-30 02:22</strong>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-message-dots"></i>
                      </span>
                      Issue:
                      <strong class="ms-2">مافي مراجعة شي لو ضايفين صور لفرجيك كيف قاعد بتتقلي ضل خلص تكرم 🤣🤣</strong>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-map-pin"></i>
                      </span>
                      Address:
                      <strong class="ms-2">شام للاتصالات</strong>
                    </div>
                  </div>



                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-notes"></i>
                      </span>
                      Notes:
                      <strong class="ms-2">خلصنا</strong>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-quote"></i>
                      </span>
                      SSR Comment:
                      <strong class="ms-2">لا تزعج الادارة يا مواطن الدنيا عيد</strong>
                    </div>
                  </div>



                </div>
              </div>

              <hr class="mb-2">
              <div class="row mb-4">
                <div class="col-12">
                  <div class="d-grid w-100 mt-4">
                    <button type="button" class="btn btn-primary">
                      <i class="ti ti-edit me-2"></i>
                      <span>Edit</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion-item card p-5 pt-0 pb-4">
            <h2 class="accordion-header">
              <div type="button" class="d-flex justify-content-between align-items-center" data-bs-toggle="collapse"
                data-bs-target="#accordionStyle1-3" aria-expanded="true">
                <div>
                  <small class="text-muted">30 Haziran 2023 / #109</small><br>
                  <div class="d-flex justify-content-start mt-n2">
                    <h3 class="mb-0 text-primary">speed problem</h3>
                  </div>
                </div>
                <div class="text-end">
                  <span class="alert alert-warning text-xs"> New </span><br>
                  <i class="ti ti-chevron-right text-muted"></i>
                </div>
              </div>
            </h2>

            <div id="accordionStyle1-3" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
              <hr class="mb-8 mt-2">
              <div class="accordion-body">
                <div class="row g-3">

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-hash"></i>
                      </span>
                      Ticket ID:
                      <strong class="ms-2">109</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-phone"></i>
                      </span>
                      Phone:
                      <strong class="ms-2">09000000000</strong>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-alert-circle"></i>
                      </span>
                      Status:
                      <strong class="ms-2 text-warning">New</strong>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-calendar"></i>
                      </span>
                      Created At:
                      <strong class="ms-2">2023-06-30 02:22</strong>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-message-dots"></i>
                      </span>
                      Issue:
                      <strong class="ms-2">مافي مراجعة شي لو ضايفين صور لفرجيك كيف قاعد بتتقلي ضل خلص تكرم 🤣🤣</strong>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-map-pin"></i>
                      </span>
                      Address:
                      <strong class="ms-2">شام للاتصالات</strong>
                    </div>
                  </div>



                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-notes"></i>
                      </span>
                      Notes:
                      <strong class="ms-2">خلصنا</strong>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-quote"></i>
                      </span>
                      SSR Comment:
                      <strong class="ms-2">لا تزعج الادارة يا مواطن الدنيا عيد</strong>
                    </div>
                  </div>



                </div>
              </div>

              <hr class="mb-2">
              <div class="row mb-4">
                <div class="col-12">
                  <div class="d-grid w-100 mt-4">
                    <button type="button" class="btn btn-primary">
                      <i class="ti ti-edit me-2"></i>
                      <span>Edit</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion-item card p-5 pt-0 pb-4">
            <h2 class="accordion-header">
              <div type="button" class="d-flex justify-content-between align-items-center" data-bs-toggle="collapse"
                data-bs-target="#accordionStyle1-4" aria-expanded="true">
                <div>
                  <small class="text-muted">30 Haziran 2023 / #109</small><br>
                  <div class="d-flex justify-content-start mt-n2">
                    <h3 class="mb-0 text-primary">speed problem</h3>
                  </div>
                </div>
                <div class="text-end">
                  <span class="alert alert-warning text-xs"> New </span><br>
                  <i class="ti ti-chevron-right text-muted"></i>
                </div>
              </div>
            </h2>

            <div id="accordionStyle1-4" class="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
              <hr class="mb-8 mt-2">
              <div class="accordion-body">
                <div class="row g-3">

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-hash"></i>
                      </span>
                      Ticket ID:
                      <strong class="ms-2">109</strong>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-phone"></i>
                      </span>
                      Phone:
                      <strong class="ms-2">09000000000</strong>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-alert-circle"></i>
                      </span>
                      Status:
                      <strong class="ms-2 text-warning">New</strong>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-calendar"></i>
                      </span>
                      Created At:
                      <strong class="ms-2">2023-06-30 02:22</strong>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-message-dots"></i>
                      </span>
                      Issue:
                      <strong class="ms-2">مافي مراجعة شي لو ضايفين صور لفرجيك كيف قاعد بتتقلي ضل خلص تكرم 🤣🤣</strong>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-map-pin"></i>
                      </span>
                      Address:
                      <strong class="ms-2">شام للاتصالات</strong>
                    </div>
                  </div>



                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-notes"></i>
                      </span>
                      Notes:
                      <strong class="ms-2">خلصنا</strong>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="alert alert-info d-flex align-items-center" role="alert">
                      <span class="alert-icon rounded me-2">
                        <i class="ti ti-quote"></i>
                      </span>
                      SSR Comment:
                      <strong class="ms-2">لا تزعج الادارة يا مواطن الدنيا عيد</strong>
                    </div>
                  </div>



                </div>
              </div>

              <hr class="mb-2">
              <div class="row mb-4">
                <div class="col-12">
                  <div class="d-grid w-100 mt-4">
                    <button type="button" class="btn btn-primary">
                      <i class="ti ti-edit me-2"></i>
                      <span>Edit</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 d-md-block d-none">
        <div class="card">
          <img class="card-img" src="@/assets/img/elements/4.jpg" alt="Card image cap" />
        </div>
      </div>
    </div>

  </div>
</template>
<script>

</script>
